import engine from '../engine';
import Vector2 from 'apollo-e/math/Vector2';
import Scene3D from 'apollo-e/Scene3D';
import QTContainer3D from '../components/QTContainer3D';
import CCContainer3D from '../components/CCContainer3D';

function createSheepBody (bodyContainer: CCContainer3D) {
  const body1 = bodyContainer.createParticle();
  body1.scales.x = 108;
  body1.scales.y = 85;
  body1.scales.z = 85;
  body1.pivots.x = 0.5;
  body1.pivots.y = 0.7;
  body1.pivots.z = 0.5;
  body1.color.r = 1.0;
  body1.color.g = 1.0;
  body1.color.b = 1.0;

  const body2 = bodyContainer.createParticle();
  body2.scales.x = 85;
  body2.scales.y = 108;
  body2.scales.z = 85;
  body2.pivots.x = 0.5;
  body2.pivots.y = 0.65;
  body2.pivots.z = 0.5;
  body2.color.r = 1.0;
  body2.color.g = 1.0;
  body2.color.b = 1.0;

  const body3 = bodyContainer.createParticle();
  body3.scales.x = 85;
  body3.scales.y = 85;
  body3.scales.z = 108;
  body3.pivots.x = 0.5;
  body3.pivots.y = 0.65;
  body3.pivots.z = 0.5;
  body3.color.r = 1.0;
  body3.color.g = 1.0;
  body3.color.b = 1.0;

  const head = bodyContainer.createParticle();
  head.position.y = 5;
  head.position.z = 60;
  head.scales.x = 54;
  head.scales.y = 64;
  head.scales.z = 35;
  head.pivots.x = 0.5;
  head.pivots.y = 0.68;
  head.pivots.z = 0.5;
  head.color.r = 0.9608;
  head.color.g = 0.8078;
  head.color.b = 0.6470;

  const earLeft = bodyContainer.createParticle();
  earLeft.position.x = 28;
  earLeft.position.y = 16;
  earLeft.position.z = 60;
  earLeft.scales.x = 12;
  earLeft.scales.y = 7;
  earLeft.scales.z = 9;
  earLeft.pivots.x = 0.0;
  earLeft.pivots.y = 0.5;
  earLeft.pivots.z = 0.5;
  earLeft.color.r = 0.9608;
  earLeft.color.g = 0.8078;
  earLeft.color.b = 0.6470;

  const earRight = bodyContainer.createParticle();
  earRight.position.x = -28;
  earRight.position.y = 17;
  earRight.position.z = 60;
  earRight.scales.x = 12;
  earRight.scales.y = 7;
  earRight.scales.z = 9;
  earRight.pivots.x = 1.0;
  earRight.pivots.y = 0.5;
  earRight.pivots.z = 0.5;
  earRight.color.r = 0.9608;
  earRight.color.g = 0.8078;
  earRight.color.b = 0.6470;

  const legLeftFront = bodyContainer.createParticle();
  legLeftFront.position.x = 12;
  legLeftFront.position.y = -70;
  legLeftFront.position.z = 30;
  legLeftFront.scales.x = 16;
  legLeftFront.scales.y = 24;
  legLeftFront.scales.z = 16;
  legLeftFront.pivots.x = 0.5;
  legLeftFront.pivots.y = 1.0;
  legLeftFront.pivots.z = 0.5;
  legLeftFront.color.r = 0.9608;
  legLeftFront.color.g = 0.8078;
  legLeftFront.color.b = 0.6470;

  const legRightFront = bodyContainer.createParticle();
  legRightFront.position.x = -12;
  legRightFront.position.y = -70;
  legRightFront.position.z = 30;
  legRightFront.scales.x = 16;
  legRightFront.scales.y = 24;
  legRightFront.scales.z = 16;
  legRightFront.pivots.x = 0.5;
  legRightFront.pivots.y = 1.0;
  legRightFront.pivots.z = 0.5;
  legRightFront.color.r = 0.9608;
  legRightFront.color.g = 0.8078;
  legRightFront.color.b = 0.6470;

  const legLeftBack = bodyContainer.createParticle();
  legLeftBack.position.x = 12;
  legLeftBack.position.y = -70;
  legLeftBack.position.z = -30;
  legLeftBack.scales.x = 16;
  legLeftBack.scales.y = 24;
  legLeftBack.scales.z = 16;
  legLeftBack.pivots.x = 0.5;
  legLeftBack.pivots.y = 1.0;
  legLeftBack.pivots.z = 0.5;
  legLeftBack.color.r = 0.9608;
  legLeftBack.color.g = 0.8078;
  legLeftBack.color.b = 0.6470;

  const legRightBack = bodyContainer.createParticle();
  legRightBack.position.x = -12;
  legRightBack.position.y = -70;
  legRightBack.position.z = -30;
  legRightBack.scales.x = 16;
  legRightBack.scales.y = 24;
  legRightBack.scales.z = 16;
  legRightBack.pivots.x = 0.5;
  legRightBack.pivots.y = 1.0;
  legRightBack.pivots.z = 0.5;
  legRightBack.color.r = 0.9608;
  legRightBack.color.g = 0.8078;
  legRightBack.color.b = 0.6470;

  const eyeLeft = bodyContainer.createParticle();
  eyeLeft.position.x = 8;
  eyeLeft.position.y = 5;
  eyeLeft.position.z = 76;
  eyeLeft.scales.x = 9;
  eyeLeft.scales.y = 18;
  eyeLeft.scales.z = 5;
  eyeLeft.pivots.x = 0.5;
  eyeLeft.pivots.y = 0.5;
  eyeLeft.pivots.z = 0.5;
  eyeLeft.color.r = 1;
  eyeLeft.color.g = 1;
  eyeLeft.color.b = 1;

  const eyeRight = bodyContainer.createParticle();
  eyeRight.position.x = -8;
  eyeRight.position.y = 5;
  eyeRight.position.z = 76;
  eyeRight.scales.x = 9;
  eyeRight.scales.y = 18;
  eyeRight.scales.z = 5;
  eyeRight.pivots.x = 0.5;
  eyeRight.pivots.y = 0.5;
  eyeRight.pivots.z = 0.5;
  eyeRight.color.r = 1;
  eyeRight.color.g = 1;
  eyeRight.color.b = 1;

  const goggleTop = bodyContainer.createParticle();
  goggleTop.position.x = 0;
  goggleTop.position.y = 15;
  goggleTop.position.z = 76;
  goggleTop.scales.x = 44;
  goggleTop.scales.y = 4;
  goggleTop.scales.z = 8;
  goggleTop.pivots.x = 0.5;
  goggleTop.pivots.y = 0.5;
  goggleTop.pivots.z = 0.5;
  goggleTop.color.r = 0;
  goggleTop.color.g = 0;
  goggleTop.color.b = 0;

  const goggleBottom = bodyContainer.createParticle();
  goggleBottom.position.x = 0;
  goggleBottom.position.y = -5;
  goggleBottom.position.z = 76;
  goggleBottom.scales.x = 44;
  goggleBottom.scales.y = 4;
  goggleBottom.scales.z = 8;
  goggleBottom.pivots.x = 0.5;
  goggleBottom.pivots.y = 0.5;
  goggleBottom.pivots.z = 0.5;
  goggleBottom.color.r = 0;
  goggleBottom.color.g = 0;
  goggleBottom.color.b = 0;

  const goggleLeft = bodyContainer.createParticle();
  goggleLeft.position.x = 20;
  goggleLeft.position.y = 5;
  goggleLeft.position.z = 76;
  goggleLeft.scales.x = 4;
  goggleLeft.scales.y = 23;
  goggleLeft.scales.z = 8;
  goggleLeft.pivots.x = 0.5;
  goggleLeft.pivots.y = 0.5;
  goggleLeft.pivots.z = 0.5;
  goggleLeft.color.r = 0;
  goggleLeft.color.g = 0;
  goggleLeft.color.b = 0;

  const goggleRight = bodyContainer.createParticle();
  goggleRight.position.x = -20;
  goggleRight.position.y = 5;
  goggleRight.position.z = 76;
  goggleRight.scales.x = 4;
  goggleRight.scales.y = 23;
  goggleRight.scales.z = 8;
  goggleRight.pivots.x = 0.5;
  goggleRight.pivots.y = 0.5;
  goggleRight.pivots.z = 0.5;
  goggleRight.color.r = 0;
  goggleRight.color.g = 0;
  goggleRight.color.b = 0;

  const goggleMiddle = bodyContainer.createParticle();
  goggleMiddle.position.x = 0;
  goggleMiddle.position.y = 5;
  goggleMiddle.position.z = 76;
  goggleMiddle.scales.x = 6;
  goggleMiddle.scales.y = 23;
  goggleMiddle.scales.z = 8;
  goggleMiddle.pivots.x = 0.5;
  goggleMiddle.pivots.y = 0.5;
  goggleMiddle.pivots.z = 0.5;
  goggleMiddle.color.r = 0;
  goggleMiddle.color.g = 0;
  goggleMiddle.color.b = 0;

  const strapLeft = bodyContainer.createParticle();
  strapLeft.position.x = -25;
  strapLeft.position.y = 5;
  strapLeft.position.z = 60;
  strapLeft.scales.x = 8;
  strapLeft.scales.y = 14;
  strapLeft.scales.z = 39;
  strapLeft.pivots.x = 0.5;
  strapLeft.pivots.y = 0.5;
  strapLeft.pivots.z = 0.5;
  strapLeft.color.r = 0.23;
  strapLeft.color.g = 0.23;
  strapLeft.color.b = 0.23;

  const strapRight = bodyContainer.createParticle();
  strapRight.position.x = 25;
  strapRight.position.y = 5;
  strapRight.position.z = 60;
  strapRight.scales.x = 8;
  strapRight.scales.y = 14;
  strapRight.scales.z = 39;
  strapRight.pivots.x = 0.5;
  strapRight.pivots.y = 0.5;
  strapRight.pivots.z = 0.5;
  strapRight.color.r = 0.23;
  strapRight.color.g = 0.23;
  strapRight.color.b = 0.23;

  const retinaLeft = bodyContainer.createParticle();
  retinaLeft.position.x = 6;
  retinaLeft.position.y = 5;
  retinaLeft.position.z = 76;
  retinaLeft.scales.x = 6;
  retinaLeft.scales.y = 8;
  retinaLeft.scales.z = 6;
  retinaLeft.pivots.x = 0.5;
  retinaLeft.pivots.y = 0.5;
  retinaLeft.pivots.z = 0.5;
  retinaLeft.color.r = 0;
  retinaLeft.color.g = 0;
  retinaLeft.color.b = 0;

  const retinaRight = bodyContainer.createParticle();
  retinaRight.position.x = -7;
  retinaRight.position.y = 3;
  retinaRight.position.z = 76;
  retinaRight.scales.x = 6;
  retinaRight.scales.y = 10;
  retinaRight.scales.z = 6;
  retinaRight.pivots.x = 0.5;
  retinaRight.pivots.y = 0.5;
  retinaRight.pivots.z = 0.5;
  retinaRight.color.r = 0;
  retinaRight.color.g = 0;
  retinaRight.color.b = 0;

  const jetpackLeft = bodyContainer.createParticle();
  jetpackLeft.position.x = 60;
  jetpackLeft.position.y = 0;
  jetpackLeft.position.z = 10;
  jetpackLeft.scales.x = 16;
  jetpackLeft.scales.y = 48;
  jetpackLeft.scales.z = 34;
  jetpackLeft.pivots.x = 0.5;
  jetpackLeft.pivots.y = 0.5;
  jetpackLeft.pivots.z = 0.5;
  jetpackLeft.color.r = 0.635;
  jetpackLeft.color.g = 0.141;
  jetpackLeft.color.b = 0.11;

  const jetpackRight = bodyContainer.createParticle();
  jetpackRight.position.x = -60;
  jetpackRight.position.y = 0;
  jetpackRight.position.z = 10;
  jetpackRight.scales.x = 16;
  jetpackRight.scales.y = 48;
  jetpackRight.scales.z = 34;
  jetpackRight.pivots.x = 0.5;
  jetpackRight.pivots.y = 0.5;
  jetpackRight.pivots.z = 0.5;
  jetpackRight.color.r = 0.635;
  jetpackRight.color.g = 0.141;
  jetpackRight.color.b = 0.11;

  return {
    legs: [legLeftFront, legRightFront, legLeftBack, legRightBack],
    earLeft, earRight, head,
    wool: body2
  };
}

function createSheepCompanionVisuals (bodyContainer: CCContainer3D) {
  const body1 = bodyContainer.createParticle();
  body1.scales.x = 108;
  body1.scales.y = 85;
  body1.scales.z = 85;
  body1.pivots.x = 0.5;
  body1.pivots.y = 0.7;
  body1.pivots.z = 0.5;
  body1.color.r = 1.0;
  body1.color.g = 1.0;
  body1.color.b = 1.0;

  const body2 = bodyContainer.createParticle();
  body2.scales.x = 85;
  body2.scales.y = 108;
  body2.scales.z = 85;
  body2.pivots.x = 0.5;
  body2.pivots.y = 0.65;
  body2.pivots.z = 0.5;
  body2.color.r = 1.0;
  body2.color.g = 1.0;
  body2.color.b = 1.0;

  const body3 = bodyContainer.createParticle();
  body3.scales.x = 85;
  body3.scales.y = 85;
  body3.scales.z = 108;
  body3.pivots.x = 0.5;
  body3.pivots.y = 0.65;
  body3.pivots.z = 0.5;
  body3.color.r = 1.0;
  body3.color.g = 1.0;
  body3.color.b = 1.0;

  const head = bodyContainer.createParticle();
  head.position.y = 5;
  head.position.z = 60;
  head.scales.x = 54;
  head.scales.y = 64;
  head.scales.z = 35;
  head.pivots.x = 0.5;
  head.pivots.y = 0.68;
  head.pivots.z = 0.5;
  head.color.r = 0.9608;
  head.color.g = 0.8078;
  head.color.b = 0.6470;

  const earLeft = bodyContainer.createParticle();
  earLeft.position.x = 28;
  earLeft.position.y = 16;
  earLeft.position.z = 60;
  earLeft.scales.x = 12;
  earLeft.scales.y = 7;
  earLeft.scales.z = 9;
  earLeft.pivots.x = 0.0;
  earLeft.pivots.y = 0.5;
  earLeft.pivots.z = 0.5;
  earLeft.color.r = 0.9608;
  earLeft.color.g = 0.8078;
  earLeft.color.b = 0.6470;

  const earRight = bodyContainer.createParticle();
  earRight.position.x = -28;
  earRight.position.y = 17;
  earRight.position.z = 60;
  earRight.scales.x = 12;
  earRight.scales.y = 7;
  earRight.scales.z = 9;
  earRight.pivots.x = 1.0;
  earRight.pivots.y = 0.5;
  earRight.pivots.z = 0.5;
  earRight.color.r = 0.9608;
  earRight.color.g = 0.8078;
  earRight.color.b = 0.6470;

  const legLeftFront = bodyContainer.createParticle();
  legLeftFront.position.x = 12;
  legLeftFront.position.y = -70;
  legLeftFront.position.z = 30;
  legLeftFront.scales.x = 16;
  legLeftFront.scales.y = 24;
  legLeftFront.scales.z = 16;
  legLeftFront.pivots.x = 0.5;
  legLeftFront.pivots.y = 1.0;
  legLeftFront.pivots.z = 0.5;
  legLeftFront.color.r = 0.9608;
  legLeftFront.color.g = 0.8078;
  legLeftFront.color.b = 0.6470;

  const legRightFront = bodyContainer.createParticle();
  legRightFront.position.x = -12;
  legRightFront.position.y = -70;
  legRightFront.position.z = 30;
  legRightFront.scales.x = 16;
  legRightFront.scales.y = 24;
  legRightFront.scales.z = 16;
  legRightFront.pivots.x = 0.5;
  legRightFront.pivots.y = 1.0;
  legRightFront.pivots.z = 0.5;
  legRightFront.color.r = 0.9608;
  legRightFront.color.g = 0.8078;
  legRightFront.color.b = 0.6470;

  const legLeftBack = bodyContainer.createParticle();
  legLeftBack.position.x = 12;
  legLeftBack.position.y = -70;
  legLeftBack.position.z = -30;
  legLeftBack.scales.x = 16;
  legLeftBack.scales.y = 24;
  legLeftBack.scales.z = 16;
  legLeftBack.pivots.x = 0.5;
  legLeftBack.pivots.y = 1.0;
  legLeftBack.pivots.z = 0.5;
  legLeftBack.color.r = 0.9608;
  legLeftBack.color.g = 0.8078;
  legLeftBack.color.b = 0.6470;

  const legRightBack = bodyContainer.createParticle();
  legRightBack.position.x = -12;
  legRightBack.position.y = -70;
  legRightBack.position.z = -30;
  legRightBack.scales.x = 16;
  legRightBack.scales.y = 24;
  legRightBack.scales.z = 16;
  legRightBack.pivots.x = 0.5;
  legRightBack.pivots.y = 1.0;
  legRightBack.pivots.z = 0.5;
  legRightBack.color.r = 0.9608;
  legRightBack.color.g = 0.8078;
  legRightBack.color.b = 0.6470;

  const eyeLeft = bodyContainer.createParticle();
  eyeLeft.position.x = 8;
  eyeLeft.position.y = 5;
  eyeLeft.position.z = 76;
  eyeLeft.scales.x = 9;
  eyeLeft.scales.y = 18;
  eyeLeft.scales.z = 5;
  eyeLeft.pivots.x = 0.5;
  eyeLeft.pivots.y = 0.5;
  eyeLeft.pivots.z = 0.5;
  eyeLeft.color.r = 1;
  eyeLeft.color.g = 1;
  eyeLeft.color.b = 1;

  const eyeRight = bodyContainer.createParticle();
  eyeRight.position.x = -8;
  eyeRight.position.y = 5;
  eyeRight.position.z = 76;
  eyeRight.scales.x = 9;
  eyeRight.scales.y = 18;
  eyeRight.scales.z = 5;
  eyeRight.pivots.x = 0.5;
  eyeRight.pivots.y = 0.5;
  eyeRight.pivots.z = 0.5;
  eyeRight.color.r = 1;
  eyeRight.color.g = 1;
  eyeRight.color.b = 1;

  const retinaLeft = bodyContainer.createParticle();
  retinaLeft.position.x = 4 + Math.random() * 4;
  retinaLeft.position.y = 3 + Math.random() * 4;
  retinaLeft.position.z = 76;
  retinaLeft.scales.x = 6;
  retinaLeft.scales.y = 8;
  retinaLeft.scales.z = 6;
  retinaLeft.pivots.x = 0.5;
  retinaLeft.pivots.y = 0.5;
  retinaLeft.pivots.z = 0.5;
  retinaLeft.color.r = 0;
  retinaLeft.color.g = 0;
  retinaLeft.color.b = 0;

  const retinaRight = bodyContainer.createParticle();
  retinaRight.position.x = -9 + Math.random() * 4;
  retinaRight.position.y = 1 + Math.random() * 4;
  retinaRight.position.z = 76;
  retinaRight.scales.x = 6;
  retinaRight.scales.y = 10;
  retinaRight.scales.z = 6;
  retinaRight.pivots.x = 0.5;
  retinaRight.pivots.y = 0.5;
  retinaRight.pivots.z = 0.5;
  retinaRight.color.r = 0;
  retinaRight.color.g = 0;
  retinaRight.color.b = 0;

  return {
    legs: [legLeftFront, legRightFront, legLeftBack, legRightBack],
    earLeft, earRight, head,
    wool: body2
  };
}

const SHEEP_SCALE = 0.82;
const bodySize = 130;
type Pose2D = { x: number; y: number; angle: number };
export default class Sheep {

  visualBody: CCContainer3D;
  jetpackContainer: QTContainer3D;
  legs: Array<any>;
  earLeft: any;
  earRight: any;
  head: any;
  wool: any;
  goggleBottom: any;
  goggleTop: any;
  goggleLeft: any;
  goggleRight: any;
  goggleMiddle: any;
  eyeLeft: any;
  eyeRight: any;

  thrustActive: boolean;
  thrustVector: Vector2;
  particleSpawnDelay: number;
  x: number;
  y: number;
  angle: number;
  dy: number;

  altitude: number;

  // Control-space rotation used while thrusting (decoupled from interpolated visuals)
  controlRotationY: number;
  controlRotationZ: number;

  constructor (textures, gameplayScene: Scene3D, depth: number) {
    this.jetpackContainer = new QTContainer3D(['position', 'vertices'], 1000);
    this.jetpackContainer.textureSet = textures.particle;
    gameplayScene.addObject(this.jetpackContainer);

    // const body = this.body = new QT3D();
    // body.textureSet = textures.sheep;
    // body.transform.position.x = 0;
    // body.transform.position.y = -280;
    // body.transform.position.z = -2;
    // body.transform.scales.x = bodySize;
    // body.transform.scales.y = bodySize;
    // body.transform.pivot = 0.5;
    // gameplayScene.addObject(body);

    const bodyPartsCount = 23;
    this.visualBody = new CCContainer3D(['rotation', 'position'], bodyPartsCount);
    gameplayScene.addObject(this.visualBody);

    const bodyTransform = this.visualBody.transform;
    bodyTransform.scale = 0.88 * SHEEP_SCALE;
    bodyTransform.position.y -= 280;
    bodyTransform.position.z -= depth / 2;

    const bodyParts = createSheepBody(this.visualBody);
    this.legs = bodyParts.legs;
    this.earLeft = bodyParts.earLeft;
    this.earRight = bodyParts.earRight;
    this.wool = bodyParts.wool;
    this.head = bodyParts.head;

    this.thrustVector = new Vector2(0, 1);
    this.thrustActive = false;
    this.particleSpawnDelay = 0;

    this.x = 0;
    this.y = -410;
    this.dy = 0;
    this.angle = 0;

    this.altitude = 0;

    this.controlRotationY = 0;
    this.controlRotationZ = 0;
  }

  private _vrand () {
    // Visual-only randomness (non-deterministic): does NOT affect simulation outcome.
    return Math.random();
  }

  updateVisual (dt: number, pose?: Pose2D) {
    const particleDim = bodySize * 0.25;
    const particleSpread = bodySize * 0.04;
    const speedCoeff = bodySize * 0.01;

    // Updating sheep visuals / particles
    const particles = this.jetpackContainer.particles;

    const x = pose ? pose.x : this.x;
    const y = pose ? pose.y : this.y;
    const bodyAngle = pose ? pose.angle : (this.angle + Math.PI / 2);

    const dx = x - this.x;
    const dy = y - this.y;
    this.x = x;
    this.y = y;
    this.dy = dy;

    const offset = 20;
    const angle = bodyAngle - Math.PI / 2;
    const sinAngle = Math.sin(angle);
    const cosAngle = Math.cos(angle);

    const bodyTransform = this.visualBody.transform;
    const thrustAngle = Math.atan2(this.thrustVector.y, this.thrustVector.x);
    if (this.thrustActive === true) {
      // Visual-only control-space smoothing (simulation owns the authoritative body angle).
      this.controlRotationY = -0.06 * (thrustAngle - Math.PI / 2);
      this.controlRotationZ = 0.3 * (thrustAngle - Math.PI / 2) + 0.7 * this.controlRotationZ;
      bodyTransform.rotation.y = this.controlRotationY;
      bodyTransform.rotation.z = this.controlRotationZ;
    } else {
      bodyTransform.rotation.z = bodyAngle % (Math.PI * 2);
    }

    bodyTransform.position.x = x - offset * cosAngle;
    bodyTransform.position.y = y - offset * sinAngle;

    const angularSpeed = angle - this.angle;
    this.angle = angle;

    this.altitude = (y + 400) / 120;

    const relativeDY = dx * cosAngle + dy * sinAngle;
    for (let l = 0; l < this.legs.length; l++) {
      const leg = this.legs[l];
      leg.position.y = -70 + relativeDY * 0.3;
      leg.rotation.z = (-10 * angularSpeed) * 0.7 + leg.rotation.z * 0.3 + (this._vrand() - 0.5) * (dx + dy) * 0.011;
    }

    this.earLeft.rotation.z = relativeDY * 0.045 - 10 * angularSpeed + (this._vrand() - 0.5) * (dx + dy) * 0.02;
    this.earRight.rotation.z = -relativeDY * 0.045 - 10 * angularSpeed + (this._vrand() - 0.5) * (dx + dy) * 0.02;
    this.wool.position.y = relativeDY * 0.16;
    this.head.position.y = relativeDY * 0.25;
    this.earLeft.position.y = 16 + relativeDY * 0.25;
    this.earRight.position.y = 17 + relativeDY * 0.25;

    if (this.thrustActive === true) {
      let t = this.particleSpawnDelay + dt;
      const spwanThreshold = 1.2;
      const thrustCos = Math.cos(thrustAngle - Math.PI / 2);
      const thrustSin = Math.sin(thrustAngle - Math.PI / 2);

      while (t > spwanThreshold) {
        const particle = this.jetpackContainer.createParticle();

        // const left = (this._rand() - 0.5) < this.thrustVector.x;
        const left = this._vrand() < 0.5;
        let x = (left ? -37 : 37) * SHEEP_SCALE;
        let y = thrustSin * x;
        x = thrustCos * x + bodyTransform.position.x;

        const particleDepth = 22 * SHEEP_SCALE;
        particle.width = particleDim;
        particle.height = particleDim;
        particle.scale = 0.8 + this._vrand() * 0.2;
        particle.position.x = (this._vrand() - 0.5) * 2 * particleSpread + x;
        particle.position.y = y + bodyTransform.position.y;
        particle.position.z = this._vrand() * particleDepth - 125;
        particle.greyShade = (125 + particle.position.z) / particleDepth * 0.6 + 0.4;
        particle.pivot = 0.5;
        particle.rotation = thrustAngle;
        particle.payload = {
          speedX: speedCoeff * (this._vrand() - 0.5) * 0.2,
          // speedX: 0,
          speedY: speedCoeff * (this._vrand() * 0.4 + 0.8) * (particleSpread - Math.abs(x - particle.position.x)) / particleSpread
        };

        t -= spwanThreshold;
      }
      this.particleSpawnDelay = t;
    }

    for (let p = 0; p < particles.length; p++) {
      const particle = particles[p];
      particle.position.x += dt * particle.payload.speedX;
      particle.position.y -= dt * particle.payload.speedY;
      particle.payload.speedX *= Math.pow(0.99, dt * 0.5);
      particle.payload.speedY *= Math.pow(0.99, dt * 0.5);
      particle.scale -= dt / 16.7 * 0.020;
      // particle.scale *= Math.pow(0.99, dt * 0.4);

      if (particle.position.y < -460) {
        particle.position.y = -460;
        const direction = particle.payload.speedX > 0 ? 1 : -1;
        particle.position.x += dt * 0.5 * direction * particle.payload.speedY;
      }

      if (particle.scale * particleDim < 1) {
        this.jetpackContainer.removeParticle(particle);
      }
    }
  }

  // Back-compat: old call site can still call update(dt), but it is now visuals-only.
  update (dt: number) {
    this.updateVisual(dt);
  }

  updateThrust (activeTouches) {
    const renderer = engine.renderer;
    const width = renderer.styleWidth;
    const height = renderer.styleHeight;

    // Average the *tap positions* (as it used to be), then derive the thrust vector from that.
    // This preserves multi-touch behavior: multiple fingers should behave like a single "virtual finger"
    // at their centroid.
    let avgX = 0;
    let avgY = 0;

    // Deterministic ordering: ensure multi-touch aggregation is stable regardless of insertion order.
    const touchIDs = Object.keys(activeTouches).sort((a, b) => {
      const na = Number(a);
      const nb = Number(b);
      const aNum = Number.isFinite(na);
      const bNum = Number.isFinite(nb);
      if (aNum && bNum) {
        return na - nb;
      }
      return a.localeCompare(b);
    });
    if (touchIDs.length === 0) {
      return;
    }
    for (let t = 0; t < touchIDs.length; t++) {
      const touchID = touchIDs[t];
      const position = activeTouches[touchID].position;
      avgX += position.x;
      avgY += position.y;
      // let x = width / 2 - position.x;
      // let y = position.y - height * 0.65;
      // if (y > 0) {
      //   dy += y;
      // } else {
      //   dy -= y;
      // }
      // dx += x;
    }

    avgX /= touchIDs.length;
    avgY /= touchIDs.length;

    const dx = width / 2 - avgX;
    const dy = Math.max(50, avgY - height * 0.65);

    // converting to angle, while clamping
    // const maxAngle = Math.PI * 0.35;
    // const angle =  Math.max(-maxAngle, Math.min(maxAngle, Math.atan2(dy, dx) - 0.5 * Math.PI)) + 0.5 * Math.PI;
    const angle =  Math.atan2(dy, dx);

    // converting to vector
    this.thrustVector.x = Math.cos(angle);
    this.thrustVector.y = Math.sin(angle);
  }
}

export function getSheepCompanionShape(scale: number = 0.82) {
  const bodyWidth = 105 * scale;
  const bodyHeight = 95 * scale;
  const legWidth = 50 * scale;
  const legHeight = 30 * scale;

  return [
    { x: 0, y: 0 }, // a
    { x: bodyWidth, y: 0 }, // b
    { x: bodyWidth, y: -bodyHeight }, // c
    { x: bodyWidth / 2 + legWidth / 2, y: -bodyHeight }, // d
    { x: bodyWidth / 2 + legWidth / 2, y: -bodyHeight - legHeight }, // e
    { x: bodyWidth / 2 - legWidth / 2, y: -bodyHeight - legHeight }, // f
    { x: bodyWidth / 2 - legWidth / 2, y: -bodyHeight }, // g
    { x: 0, y: -bodyHeight }, // h
  ];
}

export class SheepCompanion {

  visualBody: CCContainer3D;
  legs: Array<any>;
  earLeft: any;
  earRight: any;
  head: any;
  wool: any;
  goggleBottom: any;
  goggleTop: any;
  goggleLeft: any;
  goggleRight: any;
  goggleMiddle: any;
  eyeLeft: any;
  eyeRight: any;

  x: number;
  y: number;
  angle: number;
  dy: number;

  altitude: number;

  constructor (gameplayScene: Scene3D, depth: number) {
    const bodyPartsCount = 21;
    this.visualBody = new CCContainer3D(['rotation', 'position'], bodyPartsCount);
    gameplayScene.addObject(this.visualBody);

    const bodyTransform = this.visualBody.transform;
    bodyTransform.scale = 0.88 * SHEEP_SCALE;
    bodyTransform.position.y -= 280;
    bodyTransform.position.z -= depth / 2;

    const bodyParts = createSheepCompanionVisuals(this.visualBody);
    this.legs = bodyParts.legs;
    this.earLeft = bodyParts.earLeft;
    this.earRight = bodyParts.earRight;
    this.wool = bodyParts.wool;
    this.head = bodyParts.head;

    this.x = 0;
    this.y = -410;
    this.dy = 0;
    this.angle = 0;

    this.altitude = 0;
  }

  private _vrand () {
    return Math.random();
  }

  updateVisual (dt: number, pose?: Pose2D) {
    const x = pose ? pose.x : this.x;
    const y = pose ? pose.y : this.y;
    const bodyAngle = pose ? pose.angle : (this.angle + Math.PI / 2);

    const dx = x - this.x;
    const dy = y - this.y;
    this.x = x;
    this.y = y;
    this.dy = dy;

    const offset = 20;
    const angle = bodyAngle - Math.PI / 2;
    const sinAngle = Math.sin(angle);
    const cosAngle = Math.cos(angle);

    const bodyTransform = this.visualBody.transform;
    bodyTransform.rotation.z = bodyAngle % (Math.PI * 2);

    bodyTransform.position.x = x - offset * cosAngle;
    bodyTransform.position.y = y - offset * sinAngle;

    const angularSpeed = angle - this.angle;
    this.angle = angle;

    this.altitude = (y + 400) / 120;

    const relativeDY = dx * cosAngle + dy * sinAngle;
    for (let l = 0; l < this.legs.length; l++) {
      const leg = this.legs[l];
      leg.position.y = -70 + relativeDY * 0.3;
      leg.rotation.z = (-10 * angularSpeed) * 0.7 + leg.rotation.z * 0.3 + (this._vrand() - 0.5) * (dx + dy) * 0.011;
    }

    this.earLeft.rotation.z = relativeDY * 0.045 - 10 * angularSpeed + (this._vrand() - 0.5) * (dx + dy) * 0.02;
    this.earRight.rotation.z = -relativeDY * 0.045 - 10 * angularSpeed + (this._vrand() - 0.5) * (dx + dy) * 0.02;
    this.wool.position.y = relativeDY * 0.16;
    this.head.position.y = relativeDY * 0.25;
    this.earLeft.position.y = 16 + relativeDY * 0.25;
    this.earRight.position.y = 17 + relativeDY * 0.25;
  }

  update (dt: number) {
    this.updateVisual(dt);
  }
}
